import React from "react";
import { StyledQuestionPreviewBox } from "./index.styled";
import { renderTextWithLineBreaks } from "../../../utils/textLineBreaks";

interface QuestionPreviewBoxProps {
  title: string;
  children: React.ReactNode;
  footerText?: string;
}

const QuestionPreviewBox: React.FC<QuestionPreviewBoxProps> = ({
  title,
  children,
  footerText,
}) => {
  return (
    <StyledQuestionPreviewBox>
      <div className="question-card-container">
        <div className="question-card">
          <div className="question-content">
            {renderTextWithLineBreaks(title)}
          </div>
        </div>
        <div className="question-note">{children}</div>
      </div>
      {footerText && (
        <div className="footer-wrapper">
          <div className="question-footer">
            {renderTextWithLineBreaks(footerText)}
          </div>
        </div>
      )}
    </StyledQuestionPreviewBox>
  );
};

export default QuestionPreviewBox;
